import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import PaymentCalculatorSectionTitle from '../PaymentCalculatorSectionTitle';
import PaymentCalculatorTooltipAnchor from '../PaymentCalculatorTooltipAnchor';
import themeStyles from './SectionTitleWithTooltip.styles';
import { EqualHeightElement } from '../../../../utils/components/EqualHeight';
import InlineTextAndTooltip from '../../../../utils/components/InlineTextTooltip';
const Title = themeStyles.apply(Box, 'Title');
const StyledTooltip = themeStyles.apply(PaymentCalculatorTooltipAnchor, 'StyledTooltip');
const SectionTitleWithTooltip = ({ title, tooltip, dataTestId, equalId = 'SectionTitleWithTooltip', }) => (React.createElement(EqualHeightElement, { name: equalId },
    React.createElement(Title, null,
        React.createElement(PaymentCalculatorSectionTitle, { "data-testid": `${dataTestId}-title` },
            React.createElement(InlineTextAndTooltip, { text: title },
                React.createElement(StyledTooltip, { contentWidth: 320, "data-testid": `${dataTestId}-tooltip` }, tooltip))))));
export default SectionTitleWithTooltip;
